import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import Button from '@Components/Button';
import Auth from '@Services/Auth';

import './BuildQueryHeading.custom.scss';
import './BuildQueryHeading.theme.scss';

const IDS_MAP = {
  0: 'Search substances, reactions and documents',
  7: 'Search substances, documents and bioactivity data',
  8: 'Search substances, reactions, documents and bioactivity data',
};

function BuildQueryHeading(props) {
  const { query, isFormsButtonsEnabled, structurePreview, goToQueryBuilderForm, qsForms, dbs, showImportModal, showStructurePopup } = props;

  const user = Auth.getUser();

  const renderDatabases = () => {
    if (query.text.length || structurePreview) {
      return null;
    }
    if (dbs.length === 1) {
      return null;
    }

    return (
      <div className="build-query-heading__left_description description">
        {dbs.map((db, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <div key={`${index}_${db.description}`}>
            {index === 0 && <span className="description__separator">in</span>}
            {index !== 0 && index === dbs.length - 1 && <span className="description__separator description__separator-full">and</span>}
            {index !== 0 && index !== dbs.length - 1 && <span className="description__separator">,</span>}
            <a className="description__item" target="_blank" href={db.hubPageURL} rel="noreferrer">
              {db.description}
            </a>
          </div>
        ))}
      </div>
    );
  };

  const renderControls = () =>
    qsForms.map((form) => (
      <Button
        key={form.title}
        title={form.title}
        type="button"
        tabIndex="0"
        onClick={() => goToQueryBuilderForm(form)}
        buttonConfig={{
          className: 'controls__button',
          type: 'tertiary',
          size: 'sm',
          ariaLabel: `Quick search for ${form.title}`,
          e2eName: 'build-query-heading-goToQueryBuilder',
        }}
        iconConfig={{
          name: form.icon.split('#icon-')[1],
          size: 'sm',
        }}
      />
    ));

  const renderHeading = () => {
    if (!query.text.length && !structurePreview) {
      return <span>{IDS_MAP[get(user, 'details.reaxysId')]}</span>;
    }

    return (
      <div>
        <span className="title__label title__separator">Search for</span>
        <span>{query.text}</span>

        {query.text.length && structurePreview ? <span className="title__separator title__separator-full">AND</span> : null}

        {structurePreview && (
          <Button
            type="button"
            tabIndex="0"
            onClick={() => showStructurePopup(structurePreview)}
            buttonConfig={{
              type: 'tertiary',
              size: 'sm',
              iconOnly: true,
              e2eName: 'build-query-heading-showStructure',
              areaLabel: 'Show quick search structure',
              className: 'title__icon',
            }}
            iconConfig={{
              name: 'structure',
              size: 'sm',
            }}
          />
        )}
      </div>
    );
  };

  return (
    <div className="build-query-heading">
      <div className="build-query-heading__right">
        <Button
          type="button"
          tabIndex="0"
          onClick={showImportModal}
          buttonConfig={{
            type: 'link',
            size: 'sm',
            label: 'Import',
            e2eName: 'build-query-heading-download',
            ariaLabel: `Import quick search query`,
          }}
          iconConfig={{
            name: 'download',
            size: 'sm',
          }}
        />
      </div>
      <div className="build-query-heading__left">
        {isFormsButtonsEnabled && <ul className="build-query-heading__left_controls controls">{renderControls()}</ul>}
        {!isFormsButtonsEnabled && (
          <>
            <h1 className="build-query-heading__left_title title">{renderHeading()}</h1>
            {renderDatabases()}
          </>
        )}
      </div>
    </div>
  );
}

BuildQueryHeading.propTypes = {
  query: PropTypes.object,
  structurePreview: PropTypes.string,
  goToQueryBuilderForm: PropTypes.func.isRequired,
  isFormsButtonsEnabled: PropTypes.bool,
  qsForms: PropTypes.array,
  dbs: PropTypes.array,
  showImportModal: PropTypes.func.isRequired,
  showStructurePopup: PropTypes.func.isRequired,
};

export default BuildQueryHeading;
